import React from 'react';
import { AppleMap } from './AppleMap';
import { GoogleMap } from './GoogleMap';
import { isAppleMap } from './LocationMapUtils';
/**
 * Map React Component: non-interactive and onclick should open a browser tab to Google Map (on mobile: default map app)
 * OR Apple Map based on CVII flag.
 * Onclick Apple Map - Always open Map application in IOS devices, open Google Map for Windows devices
 * Implemented with static version of Google Map: https://developers.google.com/maps/documentation/static-maps/
 * @param {string} googleApiKey: Google API key with static map app authenticated
 * @param {object} address: text address to send to Google API
 * NOTE: on accessibility: background (not inline) image is used to center image without measuring container size.
 * Should revert to inline image element once IE/Edge support: http://caniuse.com/#feat=object-fit
 */
export default function LocationMap(props) {
    var _a = props.address, address1 = _a.address1, address2 = _a.address2, address3 = _a.address3, city = _a.city, stateCode = _a.stateCode, postalCode = _a.postalCode, countryCode = _a.countryCode, googleApiKey = props.googleApiKey, clickable = props.clickable, width = props.width, height = props.height, scale = props.scale, zoom = props.zoom, translate = props.translate, flexEventLocationMapType = props.flexEventLocationMapType, appleMapToken = props.appleMapToken;
    var urlAddress = encodeURIComponent([address1, address2, address3, city, stateCode, postalCode, countryCode].join(' '));
    if (isAppleMap(flexEventLocationMapType)) {
        return (React.createElement(AppleMap, { address1: address1, city: city, stateCode: stateCode, countryCode: countryCode, appleMapToken: appleMapToken, clickable: clickable, urlAddress: urlAddress }));
    }
    return (React.createElement(GoogleMap, { translate: translate, googleApiKey: googleApiKey, clickable: clickable, width: width, height: height, scale: scale, zoom: zoom, urlAddress: urlAddress }));
}
LocationMap.defaultProps = {
    clickable: true,
    width: 640,
    height: 480,
    scale: 2,
    zoom: 15
};
